export default __webpack_public_path__ + "static/media/trees-henry.bbf5ccc0.jpg";